import React, { FC } from 'react'
import styled, { CSSProperties } from 'styled-components'

export const Connector: FC<Required<ConnectorType>> = ({
  moveX,
  moveY,
  width,
  height,
  type = 'straight',
  style,
  direction = 'clockwise',
}) => {
  const svgWidth = Math.max(1, Math.abs(width))
  const svgHeight = Math.max(1, Math.abs(height))

  const anchorVert = height === 0 ? '' : height > 0 ? 'bottom' : 'top'
  const anchorHori = width === 0 ? '' : width > 0 ? 'right' : 'left'
  const anchor = anchorVert + (anchorHori && anchorVert ? '-' : '') + anchorHori

  const start = {
    x: anchor === 'bottom-left' ? Math.abs(width) : 0,
    y: anchor === 'top-right' ? Math.abs(height) : 0,
  }
  const end = {
    x: anchor === 'bottom-left' ? 0 : Math.abs(width),
    y: anchor === 'top-right' ? 0 : Math.abs(height),
  }
  const needToBeReversed =
    anchor === 'top' || anchor === 'left' || anchor === 'top-left'

  return (
    <ConnectorRoot
      {...{ moveX, moveY }}
      width={svgWidth}
      height={svgHeight}
      viewBox={`0 0 ${svgWidth} ${svgHeight}`}
    >
      <LineEnd color={style.stroke || style.fill} />

      {type === 'curved' && anchor.includes('-') && (
        <Curved
          start={needToBeReversed ? end : start}
          end={needToBeReversed ? start : end}
          style={style}
          direction={direction}
        />
      )}
      {(type === 'straight' || !anchor.includes('-')) && (
        <Straight
          start={needToBeReversed ? end : start}
          end={needToBeReversed ? start : end}
          style={style}
        />
      )}
    </ConnectorRoot>
  )
}
const Curved = ({
  start,
  end,
  style,
  direction = 'clockwise',
}: {
  start: { x: number; y: number }
  end: { x: number; y: number }
  style: CSSProperties
  direction?: 'clockwise' | 'counterclockwise'
}) => {
  const controlPointClockwise = {
    x: start.x + (end.x - start.x),
    y: start.y,
  }
  const controlPointCounterClockwise = {
    x: start.x,
    y: start.y + (end.y - start.y),
  }

  return (
    <path
      d={
        `M${start.x},${start.y} ` +
        (direction === 'clockwise'
          ? `S${controlPointClockwise.x},${controlPointClockwise.y} `
          : `S${controlPointCounterClockwise.x},${controlPointCounterClockwise.y} `) +
        `${end.x},${end.y}`
      }
      markerStart='url(#triangle)'
      style={style}
      fill='none'
    />
  )
}
const Straight = ({
  start,
  end,
  style,
}: {
  start: { x: number; y: number }
  end: { x: number; y: number }
  style: CSSProperties
}) => {
  return (
    <line
      x1={start.x}
      y1={start.y}
      x2={end.x}
      y2={end.y}
      style={style}
      markerStart='url(#triangle)'
    />
  )
}
const LineEnd = ({ color = '#202346' }: { color?: string }) => {
  return (
    <defs>
      <marker
        id='triangle'
        viewBox='-2 0 12 10'
        refX='1'
        refY='5'
        markerUnits='strokeWidth'
        markerWidth={10}
        markerHeight={10}
        orient='auto'
      >
        <path d='M 10 0 L 0 5 L 10 10 z' fill={color} />
      </marker>{' '}
    </defs>
  )
}

const ConnectorRoot = styled.svg<{
  moveX: number
  moveY: number
  width: number
  height: number
}>`
  overflow: visible;
  height: ${({ height }) => Math.abs(height) + 'px'};
  width: ${({ width }) => Math.abs(width) + 'px'};
  position: absolute;
  top: 0;
  transform: ${({ moveX, moveY }) =>
    `translate(${moveX + '%'},${moveY + '%'})`};
`
